var surround = require('./surround');

module.exports = function quote(str, quoteChar) {
  return surround(str, quoteChar || '"');
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/quote.js
// module id = r3yb
// module chunks = 0